export default __webpack_public_path__ + "static/media/eng_3.1f8b837a.png";